import { render, staticRenderFns } from "./OrderExpresslist.vue?vue&type=template&id=6b9b061a&scoped=true&"
import script from "./OrderExpresslist.vue?vue&type=script&lang=js&"
export * from "./OrderExpresslist.vue?vue&type=script&lang=js&"
import style0 from "./OrderExpresslist.vue?vue&type=style&index=0&id=6b9b061a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9b061a",
  null
  
)

export default component.exports